import styled from "styled-components"

export default function MyWalletLogo() {
    return (
        <Text>MyWallet</Text>
    )
}

const Text = styled.h1`
    font-family: 'Saira Stencil One', cursive;
    font-weight: 400;
    font-size: 32px;
`

